/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Nav, Tab } from 'react-bootstrap';
import {
  faChartLine,
  faEllipsis,
  faIdBadge,
  faPaperclip,
  faListAlt,
  faCalendarDays,
  faClipboardList,
  faUserCheck
} from '@fortawesome/free-solid-svg-icons';
import { employeeActivities } from 'data/crm/dealDetailsData';
import EmployeeDetailsActivity from './detail-tabs/EmployeeDetailsActivity';
import EmployeeDetailsAttachments from './detail-tabs/EmployeeDetailsAttachments';
import generic40 from 'assets/img/generic/40.png';
import IdentificationDetail from './detail-tabs/IdentificationDetail';
import EmployeeMoreDetail from './detail-tabs/EmployeeMoreDetail';
import EmployeeLeaveDetails from './detail-tabs/EmployeeLeaveDetails';
import EmployeeListDetails from './detail-tabs/EmployeeListDetails';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import EmployeePermission from './detail-tabs/EmployeePermission';
import EmployeeSaleryStructure from './detail-tabs/EmployeeSaleryStructure';
import EmployeeServiceHistory from './detail-tabs/EmployeeServiceHistory';

const attachments = [
  {
    name: 'Aadhaar_front.png',
    mimeType: 'image',
    size: '768kb',
    user: 'xxxx xxxx 1234',
    date: '11th Jul, 12:56 PM',
    thumbnail: generic40
  },
  {
    name: 'Aadhaar_back.png',
    mimeType: 'image',
    size: '130 kb',
    user: 'xxxx xxxx 1234',
    date: '11th Jul, 08:56 PM'
  },
  {
    name: 'pan_card.png',
    mimeType: 'image',
    size: '123 kb',
    user: 'xxxxxxxx23',
    date: '11th Jul, 12:56 PM'
  },
  {
    name: 'passport_card.png',
    mimeType: 'image',
    size: '123 kb',
    user: 'xxxxxxxx54',
    date: '11th Jul, 12:56 PM'
  }
];

const EmployeeDetailsTab = ({ data, defaultTab = 'all details' }) => {
  console.log('🚀 ~ EmployeeDetailsTab ~ data:', data);
  const [activeKey, setActiveKey] = useState(defaultTab);
  const [searchParams, setSearchParams] = useSearchParams();
  const tabItems = [
    // {
    //   name: 'Activity',
    //   icon: faChartLine,
    //   content: (
    //     <EmployeeDetailsActivity
    //       data={data || {}}
    //       activities={employeeActivities}
    //     />
    //   )
    // },
    {
      name: 'Identification Details',
      icon: faIdBadge,
      content: <IdentificationDetail data={data || {}} />
    },
    {
      name: 'Attachments',
      icon: faPaperclip,
      content: (
        <EmployeeDetailsAttachments
          data={data || {}}
          attachments={attachments}
        />
      )
    },
    {
      name: 'Attendance',
      icon: faClipboardList,
      content: <EmployeeListDetails data={data || {}} />
    },
    
      // <EmployeePermission data={data || {}} />

    {
      name: 'Leave',
      icon: faCalendarDays,
      content: <EmployeeLeaveDetails data={data || {}} />
    },

    {
      name: 'Salary Structure',
      icon: faClipboardList,
      content: <EmployeeSaleryStructure data={data || {}} />
    },
    {
      name: 'Service History',
      icon: faUserCheck,
      content: <EmployeeServiceHistory data={data || {}} />
    },
    {
      name: 'All Details',
      icon: faEllipsis,
      content: <EmployeeMoreDetail data={data || {}} />
    }
  ];

  const handleChangeTab = tab => {
    setActiveKey(tab);
    setSearchParams({ tab: tab });
    // searchParams.set('tab', tab);
    // setSearchParams(searchParams);
  };

  useEffect(() => {
    if (searchParams) {
      const tabParam = searchParams.get('tab');
      if (tabParam) {
        setActiveKey(tabParam);
      } else {
        setSearchParams({ tab: defaultTab });
      }
    }
  }, []);

  return (
    <Tab.Container activeKey={activeKey} onSelect={handleChangeTab}>
      <Nav
        variant="underline"
        className="deal-details scrollbar flex-nowrap w-100 pb-1 mb-6"
      >
        {tabItems.map(item => (
          <Nav.Item key={item.name} className="me-2 text-nowrap">
            <Nav.Link eventKey={item.name.toLowerCase()}>
              <FontAwesomeIcon
                icon={item.icon}
                className="me-2 tab-icon-color"
              />
              {item.name}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
      <Tab.Content>
        {tabItems.map(item => (
          <Tab.Pane key={item.name} eventKey={item.name.toLowerCase()}>
            {item.content}
          </Tab.Pane>
        ))}
      </Tab.Content>
    </Tab.Container>
  );
};

export default EmployeeDetailsTab;
